<template>
  <div>
    <div class="relative overflow-visible">
      <div class="relative">

        <label 
          :for="triggerUniqueId"
          v-if="showIcon"
          class="absolute w-10 right-0 top-0 bottom-0 text-beige-400 text-2xl text-center pt-2.5 cursor-pointer"
        >
          <img src="/dist/icons/calendar2.svg" class="style-icon" alt="calendar">
        </label>
        <input
          :name="name"
          type="text"
          :id="triggerUniqueId"
          :placeholder="placeholder"
          v-model="inputValue"
          @blur="onManualInput"
          @keyup.enter="onManualInput"
        />
      </div>

      <AirbnbStyleDatepicker
        :trigger-element-id="triggerUniqueId"
        :months-to-show="1"
        mode="single"
        :fullscreen-mobile="false"
        :showShortcutsMenuTrigger="false"
        :date-one="dateOne"
        class="date-picker--open-up !left-0"
        @date-one-selected="handleInput"
      />
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import { format, parse, isValid } from 'date-fns'
import da from 'date-fns/locale/da'

const datepickerOptions = require('./date-picker-options')
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

export default {
  name: 'DatePickerAirBnb',

  props: {
    value: String,
    name: String,
    placeholder: String,
    showIcon: Boolean,
    dateFormat: {
      type: String,
      default: 'DD.MM.YYYY'
    }
  },

  data() {
    return {
      triggerUniqueId: `datepicker-${Math.random().toString(36).substring(2, 9)}`,
      inputValue: '',
    }
  },

  computed: {
    dateOne() {
      return this.value || ''
    }
  },

  mounted() {
    if (this.value) {
      const p = parse(this.value, 'YYYY-MM-DD', new Date())
      if (isValid(p))
        this.inputValue = format(p, this.dateFormat, { locale: da })
    }
  },

  methods: {
    handleInput(val) {
      const parsed = parse(val, 'YYYY-MM-DD', new Date())
      if (!isValid(parsed)) return

      this.inputValue = format(parsed, this.dateFormat, { locale: da })
      this.$emit('input', val)
    },

    onManualInput() {
      const cleaned = this.inputValue.replace(/[^0-9\-\/.]/g, '')
      const parsed = this.smartParse(cleaned)

      if (parsed && isValid(parsed)) {
        const yyyy = format(parsed, 'YYYY')
        const mm = format(parsed, 'MM')
        const dd = format(parsed, 'DD')

        const iso = `${yyyy}-${mm}-${dd}`

        this.$emit('input', iso)
        this.inputValue = format(parsed, this.dateFormat, { locale: da })
      } else {
        if (this.value) {
          const p = parse(this.value, 'YYYY-MM-DD', new Date())
          this.inputValue = format(p, this.dateFormat, { locale: da })
        } else {
          this.inputValue = ''
        }
      }
    },

    smartParse(text) {
      const parts = text.split(/[-.\/]/)
      if (parts.length !== 3) return null

      let [dd, mm, yy] = parts.map(p => p.padStart(2, '0'))

      if (yy.length === 2) {
        yy = parseInt(yy, 10) > 50 ? '19' + yy : '20' + yy
      }

      return parse(`${yy}-${mm}-${dd}`, 'YYYY-MM-DD', new Date())
    }
  }
}
</script>
